export default interface ISampleGradeProductFormData {
    requestId: string;
    sampleId: string;
    name: string;
    codeId: string;
  }
  
  export class SampleGradeProductFormData implements ISampleGradeProductFormData {
    requestId: string;
    sampleId: string;
    name: string;
    codeId: string;
  
    constructor(
        requestId: string,
        sampleId: string,
        name: string,
        codeId: string,
    ) {
      this.requestId = requestId;
      this.sampleId = sampleId;
      this.name = name;
      this.codeId = codeId;
      
    }
  }
  
  const defaultSampleGradeProductFormData = new SampleGradeProductFormData("", "", "", "");
    export {defaultSampleGradeProductFormData};
  